import { render, staticRenderFns } from "./floatBall.vue?vue&type=template&id=5ede90a1&scoped=true&"
import script from "./floatBall.vue?vue&type=script&lang=js&"
export * from "./floatBall.vue?vue&type=script&lang=js&"
import style0 from "./floatBall.vue?vue&type=style&index=0&id=5ede90a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ede90a1",
  null
  
)

export default component.exports